import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CalendarService, ICalendar, IResponseCalendar } from '@shared/services/calendar.service';
import { ValidatorPatterns } from '@shared/validatorpatterns';

@Component({
	selector: 'app-create-calendar',
	templateUrl: './create-calendar.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateCalendarComponent implements OnInit {
	@Output() created: EventEmitter<any> = new EventEmitter();
	form: FormGroup;
	loading: boolean = false;
	calendar: ICalendar = {
		id: '',
		alias: '',
		description: '',
	};

	httpError: string = '';

	constructor(
		public dialogRef: MatDialogRef<CreateCalendarComponent>,
		private calendarService: CalendarService,
		private fb: FormBuilder,
	) {
		this.calendar = {
			id: null,
			alias: null,
			description: null,
		};
	}

	ngOnInit(): void {
		this.initializeForm();
	}

	initializeForm(): void {
		this.form = this.fb.group({
			alias: [this.calendar.alias, [Validators.required, Validators.maxLength(255), Validators.pattern(ValidatorPatterns.Alias)]],
		});
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.calendar) {
					this.calendar[key] = value[key];
				}
			});
		});
	}

	getFirstValidationErrorName(formControlName: string) {
		return Object.keys(this.form.controls[formControlName].errors)[0];
	}

	get controls() {
		return this.form.controls;
	}

	onCancel = () => this.dialogRef.close();

	onSave() {
		if (this.loading) return;
		this.httpError = '';
		if (this.form.valid) {
			this.loading = true;
			this.calendarService.createCalendar(this.calendar).subscribe({
				next: (newCalendar: IResponseCalendar) => {
					this.created.emit(newCalendar);
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
		}
	}
}
